import { Module, Mutation, Action, VuexModule } from "vuex-module-decorators";
import { SMCases, SMUser } from "@/store";
import { API_TNps_Score } from "@/models/nps_score";
import { getNpsScoreKeyByValue } from "@/constants/nps_score_types";

@Module({ name: "MNps", namespaced: true })
export default class MNps extends VuexModule {
  isNpsOpen = false;

  @Mutation
  openNps() {
    this.isNpsOpen = true;
  }

  @Mutation
  closeNps() {
    this.isNpsOpen = false;
  }

  npsScoreCollected: API_TNps_Score = {
    skilled_worker: false,
    skilled_worker_inside: false,
    sponsor_licence: false,
    skilled_worker_cos: false,
    skilled_worker_cos_inside: false,
    report_change: false,
    monthly_checklist: false,
    // dependant: false,
    // candidate_assessment: false,
  };

  @Mutation
  setNpsScoreCollected(payload: API_TNps_Score) {
    this.npsScoreCollected = payload;
  }

  @Mutation
  unsetNpsScoreCollected() {
    this.npsScoreCollected = null;
  }

  npsTypeName = "";

  @Mutation
  setNpsTypeName(payload: string) {
    this.npsTypeName = payload;
  }

  @Action
  async checkNps(npsType = "") {
    if (!SMUser.isEmployer) return;

    if (npsType !== "report_change" && SMCases.isNpsRated) return;

    let typeName = "";

    if (npsType === "report_change") {
      typeName = "report_change";
    } else {
      const name = SMCases.caseType;
      typeName = getNpsScoreKeyByValue(name);
    }

    if (!typeName) return;

    this.setNpsTypeName(typeName);

    if (this.npsScoreCollected[typeName]) return;

    /*
    true - has been collected
    false - should be collected
    */
    if (localStorage.getItem(`nps_${typeName}`) === "true") return;

    this.npsScoreCollected[typeName] = true;

    this.openNps();
  }

  @Action
  async removeFromLocalStorage(typeName: string) {
    if (!typeName) return;

    localStorage.removeItem(`nps_${typeName}`);
  }
}
